module.exports = __webpack_public_path__ + "static/media/tutorial-03.30d22548.gif";